/* Click-and-drag for horizontal sliders.
   A native overflow-x scroller can be swiped on a touch screen and scrolled
   with a trackpad, but it CANNOT be dragged with a mouse — which is what most
   desktop visitors try first. This adds pointer grab-drag to Dawn's sliders.

   Two things it has to get right:
     - scroll-snap fights a drag, so it is switched off while dragging
     - the click that fires at the end of a drag must not open the product,
       otherwise every drag lands you on a product page */
(function () {
  'use strict';

  var SEL = 'slider-component .slider, .afb-rail, .image-gallery-grid';

  function init(el) {
    if (el.dataset.afbDrag) return;
    el.dataset.afbDrag = '1';

    var down = false, startX = 0, startLeft = 0, moved = 0, id = null;

    el.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 || e.pointerType === 'touch') return;   // let touch do its native thing
      down = true; moved = 0; id = e.pointerId;
      startX = e.clientX; startLeft = el.scrollLeft;
      el.classList.add('afb-grabbing');
    });

    el.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== id) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) {
        moved = Math.abs(dx);
        el.classList.add('afb-dragging');
        el.scrollLeft = startLeft - dx;
        e.preventDefault();
      }
    });

    function end() {
      if (!down) return;
      down = false; id = null;
      el.classList.remove('afb-grabbing', 'afb-dragging');
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('pointerleave', end);

    // capture phase so it beats the card's own link handler
    el.addEventListener('click', function (e) {
      if (moved > 5) { e.preventDefault(); e.stopPropagation(); moved = 0; }
    }, true);

    el.addEventListener('dragstart', function (e) { if (moved > 5) e.preventDefault(); });
  }


  /* ---- arrows, for rails that have no controls of their own ------------- */
  var ARROW = 'M9 5l7 7-7 7';
  function svg(flip) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round"' + (flip ? ' style="transform:rotate(180deg)"' : '') +
      '><path d="' + ARROW + '"/></svg>';
  }
  function addArrows(el) {
    if (el.dataset.afbArrows) return;
    el.dataset.afbArrows = '1';
    var parent = el.parentElement;
    if (!parent) return;
    parent.classList.add('afb-railwrap');
    /* build a controls bar and move the heading into it if there is one */
    if (!parent.querySelector('.afb-railctl')) {
      var bar = document.createElement('div');
      bar.className = 'afb-railctl';
      var h = parent.querySelector('h2');
      if (h) { parent.insertBefore(bar, h); bar.appendChild(h); }
      else { parent.insertBefore(bar, el); }
    }

    function mk(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'afb-arrow afb-arrow--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', dir < 0 ? 'Previous' : 'Next');
      b.innerHTML = svg(dir < 0);
      b.addEventListener('click', function () {
        /* advance exactly one item, not a viewport: measure the first child and
           add the flex gap, so the rail always lands on an item edge rather
           than part way through a photograph */
        var item = el.firstElementChild;
        var gap = parseFloat(getComputedStyle(el).columnGap || getComputedStyle(el).gap) || 0;
        var step = item ? Math.round(item.getBoundingClientRect().width + gap)
                        : Math.round(el.clientWidth * 0.8);
        el.scrollBy({ left: dir * step, behavior: 'smooth' });
      });
      /* prefer a controls bar beside the heading, so an arrow never sits on
         top of a photograph; fall back to overlaying if there is no bar */
      var bar = parent.querySelector('.afb-railctl');
      (bar || parent).appendChild(b);
      return b;
    }
    var prev = mk(-1), next = mk(1);

    function sync() {
      /* the rail carries horizontal padding so it can run to the edge of the
         viewport, and scroll-snap parks the first item past it — so a rail at
         its start sits at scrollLeft == paddingLeft, not 0. Comparing against
         0 left the "previous" arrow permanently enabled. */
      var padL = parseFloat(getComputedStyle(el).paddingLeft) || 0;
      var max = el.scrollWidth - el.clientWidth - 2;
      prev.disabled = el.scrollLeft <= padL + 4;
      next.disabled = el.scrollLeft >= max;
    }
    el.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }


  /* ---- unify Dawn's slider controls with the rail controls -------------- */
  function unifyDawn(sc) {
    if (sc.dataset.afbCtl) return;
    var btns = sc.querySelector('.slider-buttons');
    if (!btns) return;
    var section = sc.closest('.shopify-section');
    var h = section && section.querySelector('h2');
    if (!h) return;
    sc.dataset.afbCtl = '1';

    var bar = document.createElement('div');
    bar.className = 'afb-railctl afb-railctl--dawn';
    h.parentNode.insertBefore(bar, h);
    bar.appendChild(h);
    bar.appendChild(btns);

    /* Dawn's arrow is a FILLED caret in a 10x6 viewBox at 30% opacity; mine is
       a stroked chevron in 24x24. Side by side on one page they read as two
       different controls, so Dawn's glyph is swapped for the same chevron.
       The button element, its aria-label and its JS handlers are untouched. */
    btns.querySelectorAll('.slider-button').forEach(function (btn) {
      var prev = /prev/i.test(btn.getAttribute('name') || btn.className);
      btn.innerHTML = svg(prev);
    });
  }

  function boot() {
    document.querySelectorAll(SEL).forEach(init);
    document.querySelectorAll('.image-gallery-grid, .afb-rail').forEach(addArrows);
    document.querySelectorAll('slider-component').forEach(unifyDawn);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
